"use client";

import { useCallback } from "react";
import { useTeacherGetPublic } from "@/hooks";
import { isNotFoundError } from "@/lib/utils/media/is-not-found-error";
import {
  TeacherPublicPageError,
  TeacherPublicPageNotFound,
  TeacherPublicPageUnavailable,
} from "./TeacherPublicPageError";
import { TeacherPublicPageSkeleton } from "./TeacherPublicPageSkeleton";
import { TeacherPublicPageView } from "./TeacherPublicPageView";

export interface TeacherPublicPageClientProps {
  teacherId: number;
}

export const TeacherPublicPageClient = ({
  teacherId,
}: TeacherPublicPageClientProps) => {
  const {
    data: teacher,
    isPending,
    isLoading,
    isError,
    isFetching,
    refetch,
    error,
  } = useTeacherGetPublic(teacherId, { enabled: teacherId > 0 });

  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);

  if ((isLoading || isPending) && !teacher) {
    return <TeacherPublicPageSkeleton />;
  }

  if (isError) {
    if (isNotFoundError(error)) {
      return <TeacherPublicPageNotFound />;
    }

    return (
      <TeacherPublicPageError onRetry={handleRetry} isRetrying={isFetching} />
    );
  }

  if (!teacher) {
    return <TeacherPublicPageNotFound />;
  }

  if (!teacher.isActive) {
    return <TeacherPublicPageUnavailable />;
  }

  return <TeacherPublicPageView teacher={teacher} teacherId={teacherId} />;
};
